/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

(function () {
  'use strict';

  document.addEventListener('change', function (e) {
    if (
      !(e.target instanceof HTMLInputElement) ||
      !e.target.classList.contains('cart-consent-checkbox')
    ) {
      return;
    }

    var checkbox = e.target;
    var ctas = checkbox.closest('.cart__ctas');
    var tsField = ctas
      ? ctas.querySelector('.cart-consent-timestamp')
      : null;

    if (!tsField) return;

    if (checkbox.checked) {
      tsField.value = formatTimestamp(new Date());
      tsField.disabled = false;
    } else {
      tsField.value = '';
      tsField.disabled = true;
    }
  });

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;

      if (!(form instanceof HTMLFormElement) || form.id !== 'cart-form') return;

      if (!e.submitter) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      if (!e.submitter.classList.contains('cart__checkout-button')) return;

      var ctas = e.submitter.closest('.cart__ctas');
      var checkbox = ctas
        ? ctas.querySelector('.cart-consent-checkbox')
        : null;
      var fehler = ctas
        ? ctas.querySelector('.cart-consent-fehler')
        : null;

      if (!checkbox) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      if (!checkbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (fehler) fehler.style.display = 'block';

        checkbox.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        return;
      }

      if (fehler) fehler.style.display = 'none';

      var tsField = ctas
        ? ctas.querySelector('.cart-consent-timestamp')
        : null;

      if (tsField && tsField.disabled) {
        tsField.value = formatTimestamp(new Date());
        tsField.disabled = false;
      }

      document.querySelectorAll('.cart__ctas').forEach(function (otherCtas) {
        if (otherCtas === ctas) return;

        var otherCheckbox = otherCtas.querySelector('.cart-consent-checkbox');
        var otherTs = otherCtas.querySelector('.cart-consent-timestamp');

        if (otherCheckbox) otherCheckbox.disabled = true;
        if (otherTs) otherTs.disabled = true;
      });
    },
    true
  );

  function formatTimestamp(date) {
    var pad = function (n) {
      return n < 10 ? '0' + n : n;
    };

    return (
      pad(date.getDate()) + '.' +
      pad(date.getMonth() + 1) + '.' +
      date.getFullYear() + ' ' +
      pad(date.getHours()) + ':' +
      pad(date.getMinutes()) + ':' +
      pad(date.getSeconds()) +
      ' (Ortszeit Kunde)'
    );
  }
})();
